import React from "react"
import PropTypes from "prop-types"
import moment from "moment"

const defaultValues = (defaultDate) => {
  const date = defaultDate ? moment(new Date(defaultDate)) : moment()

  return {
    id: null,
    interval: 'Week',
    startDate: date,
    endDate: date
  }
}

const AddItem = ({fields, defaultDate}) => (
  <div className="form-group">
    <button className="link" type="button" onClick={() => fields.push(defaultValues(defaultDate))}>
      + Recurring Reservation
    </button>
  </div>
)

AddItem.propTypes = {
  fields: PropTypes.object,
  defaultDate: PropTypes.string
}

export default AddItem
